import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { resetFilters } from '../redux/slices/filters';
import { setFolderId } from '../redux/slices/meQrData';

const useResetFilters = () => {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(resetFilters());
    dispatch(setFolderId(null));

    const url = new URL(window.location.href);
    url.searchParams.delete('id');
    window.history.replaceState({}, document.title, url.toString());
  }, [dispatch]);
};

export default useResetFilters;
